// Single shared chart palette — every dashboard page previously declared its
// own near-identical CHART_COLORS array (a few pages started with #667eea,
// others with #2563eb, for no functional reason). One shared, richer palette
// keeps every chart across the app visually consistent.
export const CHART_COLORS = [
  '#667eea', // indigo (brand primary)
  '#22c55e', // green
  '#f59e0b', // amber
  '#e11d48', // rose
  '#0ea5e9', // sky
  '#9333ea', // purple
  '#14b8a6', // teal
  '#f97316', // orange
];

export const getChartColor = (index) => CHART_COLORS[index % CHART_COLORS.length];
